"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const stdGrid_1 = require("../stdGrid");
const globals_1 = require("../../models/globals");
const boutons_1 = require("../../outils/boutons");
const brouillonsFactures_1 = require("../../models/brouillonsFactures");
class BrouillonsFactures extends stdGrid_1.default {
    constructor(app, name) {
        super(app, name, {
            moduleName: "brouillonsFactures",
            datatableName: "facturesAttentedatatable",
            columns: brouillonsFactures_1.brouillonsFacturesColumns,
            title: (0, globals_1._)("Brouillons factures et avoirs"),
            boutons: [boutons_1.ouvrirButton, boutons_1.supprimerButton],
            resizeColumn: true,
            urlData: globals_1.phpPath + "factures.php?option=brouillonsFactures"
        });
    }
    ouvrir() {
        let idDoc = this.getSelectedIdDoc();
        if (idDoc > 0) {
            let menuGauche = $$("menu");
            menuGauche.unselectAll();
            window.location.href = "#!/pgiLayout/factures?unid=" + idDoc;
        }
    }
    init() {
        this.currentGrid = $$("facturesAttentedatatable");
        // @ts-ignore
        this.currentGrid.config.footer = true;
        let me = this;
        this.currentGrid.attachEvent("onItemDblClick", function () {
            me.ouvrir();
        });
        let menu = this.$$("stdGridMenu");
        menu.attachEvent("onMenuItemClick", function (id, e, node) {
            switch (id) {
                case "ouvrirButton":
                    me.ouvrir();
                    break;
                case "supprimerButton":
                    me.supprimerDocuments();
                    break;
                case "actualiserButton":
                    me.reload();
                    break;
            }
        });
    }
    ready() {
        let menu = this.$$("stdGridMenu");
        menu.hideMenuItem("ouvrirButton");
        if ((globals_1.lv2.droits).includes("facturation.read")) {
            menu.showMenuItem("ouvrirButton");
        }
        menu.hideMenuItem("supprimerButton");
        if ((globals_1.lv2.droits).includes("facturation.delete")) {
            menu.showMenuItem("supprimerButton");
        }
    }
}
exports.default = BrouillonsFactures;
